export const VACANCY_OF_THE_DAY_UTMS = {
    utm_source: 'headhunter',

    utm_medium: 'vacancy_search_results',

    utm_campaign: 'vacancy_of_the_day_to',
};
